import { useState } from "react";

const STORAGE_KEY = "teammate-panel-open";
const SIDE_BY_SIDE = "(min-width: 1280px)";

function isSideBySide(): boolean {
  return window.matchMedia(SIDE_BY_SIDE).matches;
}

function readStored(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function store(open: boolean) {
  try {
    localStorage.setItem(STORAGE_KEY, open ? "1" : "0");
  } catch {
    return;
  }
}

export function useTeammatePanel() {
  const [open, setOpenState] = useState(
    () => isSideBySide() && readStored() === "1",
  );

  function setOpen(next: boolean) {
    setOpenState(next);
    if (isSideBySide()) store(next);
  }

  function dismissOverlay() {
    if (!isSideBySide()) setOpenState(false);
  }

  return { open, setOpen, toggle: () => setOpen(!open), dismissOverlay };
}
